<template>
  <div class="menu-wrap">
    <el-container class="menu-container">
      <el-aside width="236px" style="background-color: rgb(238, 241, 246)">
        <el-menu :default-openeds="openeds">
          <el-submenu v-for="(item, index) in menu" :key="index" :index="index + ''" :class="openeds[0] === index + '' ? 'opt-active' : ''">
            <template slot="title">
              <i v-if="index === 0" class="el-icon-menu"></i>
              <i v-if="index === 1" class="el-icon-user-solid"></i>
              <i v-if="index === 2" class="el-icon-s-tools"></i>
              {{item.title}}
            </template>
            <el-menu-item-group>
              <el-menu-item v-if="opt.href !== 'platform'" :class="thisPath === opt.href ? 'menu-active' : ''"
                            v-for="(opt, indexO) in item.children" :key="indexO"
                            :index="index + '-' + indexO" @click="otPath(opt.href)">{{opt.title}}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data () {
    return {
      menu: [],
      openeds: [],
      thisPath: ''
    }
  },
  methods: {
    otPath (path) {
      if (this.thisPath === path) {
        return
      }
      this.$router.push({path: path})
    }
  },
  mounted () {
    this.menu = JSON.parse(window.sessionStorage.user).menuList
    this.thisPath = this.$route.path
    if (this.thisPath === '/platform/CourseContManage') { // 判断子页面路由使父页面菜单选中状态
      this.thisPath = '/platform/CourseManage'
    }
    for (let i = 0; i < this.menu.length; i++) {
      for (let j = 0; j < this.menu[i].children.length; j++) {
        if (this.menu[i].children[j].href === this.thisPath) {
          this.openeds.push(i + '') // 加空字符串，否则不显示
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/public/Menu.vue